import { CooperationDataModel } from '../models/view/CooperationData';

export class CooperationPersistenceService {
	public static readonly DEFAULT_SESSION_KEY = 'application.cooperation';

	/***
	 * Clears the cooperation-specific content in session storage.
	 */
	public clearSession(): void {
		T.Utils.Store.set(CooperationPersistenceService.DEFAULT_SESSION_KEY, null, T.Utils.Store.SESSION);
	}

	private setCooperationModel(cooperationModel: CooperationDataModel): void {
		T.Utils.Store.set(CooperationPersistenceService.DEFAULT_SESSION_KEY, cooperationModel, T.Utils.Store.SESSION);
	}

	private getCooperationModel(): CooperationDataModel {
		return T.Utils.Store.get(CooperationPersistenceService.DEFAULT_SESSION_KEY, T.Utils.Store.SESSION);
	}

	public setCooperationModelToStore(cooperationModel: CooperationDataModel): void {
		this.setCooperationModel(cooperationModel);
	}

	public getCooperationModelFromStore(): CooperationDataModel {
		return this.getCooperationModel();
	}

	public getDynamicsFieldsFromStore(): { [key: string]: any } {
		const cooperationModel = this.getCooperationModel();
		if (cooperationModel) {
			return cooperationModel.Dynamics;
		} else {
			return {};
		}
	}
}
